import { render, staticRenderFns } from "./ContainerResolutionDetails.vue?vue&type=template&id=73dc591e&"
import script from "./ContainerResolutionDetails.vue?vue&type=script&lang=js&"
export * from "./ContainerResolutionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports